import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Askforsave from "../common/confirmSubmit";
import { toast } from "react-toastify";
// import ConfirmSave from '../common/confirmSubmit'

const schema = yup.object({
  chipsupplier: yup
    .number()
    .integer()
    .required()
    .min(0)
    .max(6, "over limit =>6"),
  name: yup
    .number("yyy")
    .positive("xxxx")
    .integer("aaaa")
    .required("zzz")
    .min(0, "ค่าต่ำสุดคือ 0")
    .max(6, "over limit =>6"),
});

const Modaleditqueue = ({
  id,
  isOpen,
  onCancel,
  onConfirm,
  list,
  onAskConfirm,
}) => {
  const [dataforsave, setdataforsave] = useState({ chipsupplier: 0, name: 0 });
  const [isAskopen, setisAskopen] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    setdataforsave(data);
    setisAskopen(true);
  };

  const handleConfirm = () => {
    setisAskopen(false);
    onConfirm(dataforsave, id);
  };
  const askcancle = () => {
    setisAskopen(false);
  };

  const handleCancle = () => {
    //console.log("id",id)
    onCancel(id);
  };

  return (
    <div>
      <Askforsave
        onConfirm={handleConfirm}
        isOpen={isAskopen}
        size="xs"
        onCancel={askcancle}
        header={"ยืนยันบันทึกรายการ ใช่หรือไม่"}
        message={
          "คิวรถเชื่อเพลิง " +
          dataforsave.name +
          " คัน คิวรถนอก " +
          dataforsave.chipsupplier +
          " คัน"
        }
        button1={"บันทึก"}
      />
      {/* <ConfirmSave
      isOpen={onAskConfirm}
      
      /> */}
      <Modal
        className="modal-dialog modal-lg"
        isOpen={isOpen}
        toggle={onCancel}
        centered
      >
        <ModalHeader className="d-flex justify-content-center">
          <span className="bi bi-gear-fill text-primary">
            แก้ไขจำนวนรถ Chip เชื้อเพลิง
          </span>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="modal-body p-0">
              <div className="card ">
                <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-primary text-light">
                  <span aria-hidden="true" className="bi bi-truck me-2"></span>
                  รถบริษัท
                </div>
                <div className="card-body p-2  d-flex justify-content-center">
                  <div className="col-lg-6 text-center ">
                    <Input
                      icon="bi bi-book-fill text-primary me-2  "
                      label="Chip เชื้อเพลิง (6 คัน / ชม.)"
                      name="name"
                      register={register}
                      required
                      errors={errors.name}
                      margin="mb-2 mt-3"
                      type="number"
                      className="text-center mt-2"
                    />
                    <span
                      className="badge rounded-pill text-danger mb-3 mt-2"
                      style={{ fontSize: "20px" }}
                    >
                      Limit ( 6 คัน / ชม. )
                    </span>
                  </div>
                </div>
              </div>
              <div className="row  mt-4 ">
                <div className="col-lg-12">
                  <div className="card  ">
                    <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-warning">
                      <span
                        aria-hidden="true"
                        className="fa fa-address-card me-2"
                      ></span>
                      รถลูกค้า
                    </div>
                    <div className="card-body p-2  d-flex justify-content-center">
                      <div className="col-lg-6 text-center ">
                        <Input
                          icon="bi bi-book-fill text-warning me-2  "
                          label="Chip เชื้อเพลิง (6 คัน / ชม.)"
                          name="chipsupplier"
                          register={register}
                          type="number"
                          required
                          errors={errors.chipsupplier}
                          margin="mb-2 mt-3"
                          className="text-center mt-2"
                        />
                        <span
                          className="badge rounded-pill text-danger mb-3 mt-2"
                          style={{ fontSize: "20px" }}
                        >
                          {" "}
                          Limit ( 6 คัน / ชม. )
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <div className="col-auto">
              <Button color="primary" onClick={handleSubmit(onSubmit)}>
                Confirm
              </Button>
            </div>
            <div className="col-auto">
              <Button color="secondary" onClick={handleCancle}>
                Cancel
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modaleditqueue;
